import React, { createContext, useContext, useState } from "react";
import axios from "axios";

export const PurchaseInvoiceContext = createContext();

export const usePurchaseInvoiceContext = () =>
  useContext(PurchaseInvoiceContext);

export const PurchaseInvoiceProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [invoices, setInvoices] = useState([]);

  const createPurchaseInvoice = async (invoiceData) => {
    setLoading(true);
    setError(null);
    setSuccess(null);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/invoice/newPurchaseInvoice.php`,
        invoiceData,
        { withCredentials: true }
      );
      setSuccess(response.data.message || "تم إنشاء فاتورة الشراء بنجاح");
      setLoading(false);
      return response.data;
    } catch (err) {
      setError(
        err.response?.data?.message || "حدث خطأ أثناء إنشاء فاتورة الشراء"
      );
      setLoading(false);
      throw err;
    }
  };

  const getPurchaseInvoices = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/invoice/getPurchaseInvoices.php`,
        { withCredentials: true }
      );
      if (response.data.status === "success") {
        setInvoices(response.data.invoices);
      }
      setLoading(false);
      return response.data;
    } catch (err) {
      setError(
        err.response?.data?.message || "حدث خطأ أثناء جلب فواتير الشراء"
      );
      setLoading(false);
      throw err;
    }
  };

  const getPurchaseInvoice = async (id) => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/invoice/getPurchaseInvoice.php?id=${id}`,
        { withCredentials: true }
      );
      setLoading(false);
      return response.data;
    } catch (err) {
      setError(
        err.response?.data?.message || "حدث خطأ أثناء جلب تفاصيل الفاتورة"
      );
      setLoading(false);
      throw err;
    }
  };

  const cancelPurchaseInvoice = async (id) => {
    setLoading(true);
    setError(null);
    setSuccess(null);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/invoice/cancelPurchaseInvoice.php?id=${id}`,
        {},
        { withCredentials: true }
      );
      setSuccess(response.data.message || "تم إلغاء الفاتورة بنجاح");
      setLoading(false);
      return response.data;
    } catch (err) {
      setError(err.response?.data?.message || "حدث خطأ أثناء إلغاء الفاتورة");
      setLoading(false);
      throw err;
    }
  };

  return (
    <PurchaseInvoiceContext.Provider
      value={{
        loading,
        error,
        success,
        invoices,
        createPurchaseInvoice,
        getPurchaseInvoices,
        getPurchaseInvoice,
        cancelPurchaseInvoice,
      }}
    >
      {children}
    </PurchaseInvoiceContext.Provider>
  );
};
